import _definePage_default_0 from '/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/forgot-password.vue?definePage&vue'
import _definePage_default_3 from '/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/login.vue?definePage&vue'
import _definePage_default_4 from '/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/not-authorized.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/dashboard',
    /* internal name: 'dashboard' */
    /* no component */
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/index.vue'),
        /* no children */
      },
      {
        path: 'ads',
        /* internal name: 'dashboard-ads' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'dashboard-ads-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'dashboard-ads-add',
                component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/ads/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'dashboard-ads-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'dashboard-ads-edit-id',
                component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/ads/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            name: 'dashboard-ads-list',
            component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/ads/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'affiliate',
        /* internal name: 'dashboard-affiliate' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'dashboard-affiliate-list',
            component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/affiliate/list.vue'),
            /* no children */
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'forgot-password',
        name: 'dashboard-forgot-password',
        component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/forgot-password.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'dashboard-login',
        component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/login.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'not-authorized',
        name: 'dashboard-not-authorized',
        component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/not-authorized.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
      {
        path: 'order',
        /* internal name: 'dashboard-order' */
        /* no component */
        children: [
          {
            path: 'edit',
            /* internal name: 'dashboard-order-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'dashboard-order-edit-id',
                component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/order/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            name: 'dashboard-order-list',
            component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/order/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'product',
        /* internal name: 'dashboard-product' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'dashboard-product-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'dashboard-product-add',
                component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/product/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'dashboard-product-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'dashboard-product-edit-id',
                component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/product/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            name: 'dashboard-product-list',
            component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/product/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'stock',
        name: 'dashboard-stock',
        component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/stock.vue'),
        /* no children */
      },
      {
        path: 'user',
        /* internal name: 'dashboard-user' */
        /* no component */
        children: [
          {
            path: 'edit',
            /* internal name: 'dashboard-user-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'dashboard-user-edit-id',
                component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/user/edit/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'wallet',
        /* internal name: 'dashboard-wallet' */
        /* no component */
        children: [
          {
            path: 'list',
            name: 'dashboard-wallet-list',
            component: () => import('/home/user/Documentos/v3/v3-wdna/v3-wdna-store/clientV2/src/router/dashboard/wallet/list.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
